import { WithAccountId } from '@mews-commander/types';
import { usePaymentsTablesContext } from '../tables/PaymentsTablesContext';
import { PaymentPlanDetailsSidePanel } from './PaymentPlanDetails/PaymentPlanDetailsSidePanel';
import { PaymentMethodDetails } from './PaymentMethodDetailSidebar/PaymentMethodDetails';

export const PaymentSidePanels = ({ accountId }: WithAccountId) => {
    const {
        selectedPaymentPlanId,
        selectedPaymentMethodDefaults,
        closePaymentPlansDetails,
        closePaymentMethodDetails,
    } = usePaymentsTablesContext();
    return (
        <>
            {selectedPaymentPlanId && (
                <PaymentPlanDetailsSidePanel
                    opened={!!selectedPaymentPlanId}
                    paymentPlanId={selectedPaymentPlanId}
                    onClose={() => closePaymentPlansDetails()}
                    accountId={accountId}
                />
            )}
            {selectedPaymentMethodDefaults && (
                <PaymentMethodDetails
                    isOpen={!!selectedPaymentMethodDefaults}
                    closeDialog={() => closePaymentMethodDetails()}
                    paymentCardId={selectedPaymentMethodDefaults.paymentMethodId}
                    accountId={accountId}
                    paymentMethodType={selectedPaymentMethodDefaults.paymentMethod}
                    title={selectedPaymentMethodDefaults.sidebarTitle}
                />
            )}
        </>
    );
};
